import CheckboxGroup from 'src/components/form/search/filters-popup/checkbox-group';
import Filters from 'src/components/form/filters/filters';
import { ContactFilters, Tag } from 'src/types';
import css from './details.module.scss';
import * as yup from 'yup';

interface ContactFilterProps {
  initialValues: ContactFilters;
  cards: { id: string; name: string }[];
  tags: Tag[];
  onSubmit: (data: Partial<ContactFilters>) => void;
}

export default function ContactFilter({ initialValues, cards, tags, onSubmit }: Readonly<ContactFilterProps>) {
  const validationSchema = yup.object({
    cards: yup.array().of(yup.string()),
    tags: yup.array().of(yup.string())
  });

  return (
    <Filters
      initialFilters={initialValues}
      validationSchema={validationSchema}
      fieldsToSubmitOnChange={['cards', 'tags']}
      onSearch={onSubmit}
      render={() => (
        <div className={css.filterContainer}>
          {cards?.length > 0 && (
            <details open>
              <summary>Підрозділ</summary>
              <section>
                <CheckboxGroup entities={cards} name='cards' title={''} />
              </section>
            </details>
          )}
          {tags?.length > 0 && (
            <details>
              <summary>Напрямок діяльності</summary>
              <section>
                <CheckboxGroup entities={tags} name='tags' title={''} />
              </section>
            </details>
          )}
        </div>
      )}
    />
  );
}
